/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-18 03:08:39
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    IUITagMoreTagsUnit,
    UITag,
    IUIRelationPair,
    EUITagRuleUnion,
} from "../core";

// @uiRelationPair is an extension of @uiToggle
//  does three things:
//  1) set uiHidden by state
//  2) set uiRequired by state
//  3) set specials.relationPair for RelationConnect to do its job.
//     if specials.relationPair is set, the relation will be deleted if state is false.

@UITag.set()
export class uiRelationPair extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.FormElement, EUITagTarget.FormSubmit];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Object];
    allowNullRule: boolean = false;

    parse(input: IUITagInput): IUITagResult | null {
        let rule: IUIRelationPair = this.parseRule(input) as unknown as IUIRelationPair;
        let moreTags: IUITagMoreTagsUnit[] = [];

        const { state } = rule;
        moreTags.push({ tag: "uiToggle", rule: { state: !!state } });
        return {
            specials: {
                /// 3) set specials.relationPair for RelationConnect to do its job.
                relationPair: rule,
                moreTags,
            },
        };
    }
}
